var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoMouseClic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4985 18.4451L30.2575 47.1548L34.4296 34.6517L46.7201 30.4075L18.4985 18.4451ZM35.1281 35.3623L45.1068 45.5136L35.1281 35.3623ZM14.2371 2.26953L16.0644 9.20055L14.2371 2.26953ZM9.41121 15.9689L2.5957 14.1099L9.41121 15.9689ZM30.1399 6.60231L25.1494 11.6792L30.1399 6.60231ZM11.8453 25.211L6.85951 30.2879L11.8453 25.211Z",
    fill: "#1E222C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1281 35.3623L45.1068 45.5136M14.2371 2.26953L16.0644 9.20055M9.41121 15.9689L2.5957 14.1099M30.1399 6.60231L25.1494 11.6792M11.8453 25.211L6.85951 30.2879M18.4985 18.4451L30.2575 47.1548L34.4296 34.6517L46.7201 30.4075L18.4985 18.4451Z",
    stroke: "#1E222C",
    strokeWidth: 4.47525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMouseClic);
export default __webpack_public_path__ + "static/media/Picto-mouse-clic.eff956cc.svg";
export { ForwardRef as ReactComponent };